var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.32,
    height: 21.32,
    viewBox: "0 0 21.32 21.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checked_14_",
    "data-name": "checked (14)",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1231",
    "data-name": "Ellipse 1231",
    cx: 10.66,
    cy: 10.66,
    r: 10.66,
    transform: "translate(0 0)",
    fill: "#39be9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39008",
    "data-name": "Group 39008",
    transform: "translate(5.704 6.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31230",
    "data-name": "Path 31230",
    d: "M90.344,202.861a.882.882,0,0,1,0,1.224l-.683.683a.882.882,0,0,1-1.224,0l-2.99-3.014a.882.882,0,0,1,0-1.224l.683-.683a.881.881,0,0,1,1.224,0Z",
    transform: "translate(-85.2 -197.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31231",
    "data-name": "Path 31231",
    d: "M169.827,125.447a.882.882,0,0,1,1.224,0l.683.683a.882.882,0,0,1,0,1.224l-5.18,5.156a.882.882,0,0,1-1.224,0l-.683-.683a.882.882,0,0,1,0-1.224Z",
    transform: "translate(-162.069 -125.2)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.2fd056717713f70296eacc1f10647e96.svg";
export { ForwardRef as ReactComponent };